import { render } from "./Weekly.vue?vue&type=template&id=1d0b3f12"
import script from "./Weekly.vue?vue&type=script&lang=js"
export * from "./Weekly.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__